<template>
	<v-row no-gutters>
		<v-col>
			<v-card class="pa-4" flat>
				<!-- SERVICE TITLE -->
				<v-card-title class="display-3">
					{{ title }}
					<v-spacer />

					<v-tooltip color="info" left>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								@click="$emit('show-overview')"
								class="float-right pa-0"
								fab
								v-bind="attrs"
								v-on="on"
							>
								<v-icon>mdi-eye</v-icon>
							</v-btn>
						</template>
						<span>Back to overview</span>
					</v-tooltip>
				</v-card-title>

				<v-card-subtitle class="text-h5" v-text="subtitle" />

				<!-- BENEFITS -->
				<v-card-text>
					<v-chip
						:key="index"
						class="ma-1"
						color="blue lighten-1"
						dark
						label
						v-for="({ title }, index) in benefits"
					>
						<v-icon left>mdi-star-circle-outline</v-icon>
						{{ title }}
					</v-chip>
				</v-card-text>

				<v-card-text v-if='files'>
					<AttachmentSection flat :files='files' />
				</v-card-text>

				<!-- MAIN CONTENT -->
				<v-card-text v-html="text" />
			</v-card>
		</v-col>
	</v-row>
</template>

<script>
import AttachmentSection from '@/components/base/AttachmentSection'

export default {
	name: 'ServiceTabItem',
	props: {
		title: String,
		icon: String,
		subtitle: String,
		text: String,
		benefits: Array,
		files: Array,
	},
	components: {
		AttachmentSection,
	},
}
</script>

<style lang="scss" scoped>
</style>